<template>
    <div>
        <div class="contact-us full-screen">
            <div class="wrapper wrapper-full-page section content">
                <div class="container mb-3">
                    <div class="container">
                        <div class="text-center">
                            <img class="mb-1 mt-5" src="@/assets/img/election_logo.png" alt="MUIC">
                        </div>
                    </div>
                </div>
                <div class="container">
                    <div class="row">
                        <div class="text-center col-sm-6 col-md-8 col-lg-8 col-xl-8">
                            <div class="a-announce">
                                <h2 class="mt-1 mb-1 font-head-event">โครงการการส่งเสริมความเป็น Global Talents สำหรับบุคลากรสายสนับสนุน ครั้งที่ 1</h2>
                            </div>
                        </div>
                        <div class="text-right col-sm-6 col-md-4 col-lg-4 col-xl-4">
                            <b-card-text>
                                <h1 class="clock-warning font-01 f-size-1 font-weight-bold mt-0 mb-1">{{ currentTime }}</h1>
                                <small class="font-02 clock-warning"><i class="fa fa-calendar mr-1" aria-hidden="true" />Today : {{ moment().format('LL') }}</small>
                            </b-card-text>
                        </div>
                    </div>
                    <div class="mt-4 row">
                        <div class="col-sm-6 col-md-5 col-lg-5 col-xl-5">
                            <h3 class="mt-1 mb-3 font-01"><strong>Your Profile</strong></h3>
                            <b-card
                                class="card-profile"
                                no-body
                            >
                                <template #header>
                                    <div class="text-center">
                                        <!-- <img class="thumbnail" src="@/assets/img/avatar.png" style="width:250px;height:250px;" alt="icon_std"> -->
                                        <b-img thumbnail style="width:250px;height:300px;" v-bind:src="`https://icapp.muic.mahidol.ac.th/source/pic/13000649.jpg`" alt="muicAvtar" ></b-img>
                                    </div>
                                </template>
                                <b-list-group class="mt-4" flush>
                                    <b-list-group-item>
                                        <strong class="font-detail-profile">ID CARD :</strong><strong class="ml-2 font-detail-profile">13000649</strong>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <p class="mb-1 text-muted font-detail-profile">Name :</p>
                                        <div class="row">
                                            <p class="col-12 text-truncate mt-1 mb-1 font-01 f-size-2">Asst. Prof. Dr.Chanchai Phonthanukitithawornkitithaworn</p>
                                        </div>
                                        <!--  -->
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <p class="mb-1 text-muted font-detail-profile">Email :</p>
                                        <div class="row">
                                            <p class="col-12 text-truncate mt-1 mb-1 font-01 f-size-2">chanchai.pho@mahidol.ac.th</p>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item class="text-center">
                                        <p class="mb-1 text-muted font-detail-profile">Event Status</p>
                                        <!-- <b-alert variant="success" show>
                                            <h3 class="mt-1 mb-1">Success</h3>
                                        </b-alert> -->
                                    </b-list-group-item>
                                </b-list-group>
                            </b-card>
                        </div>
                        <div class="col-sm-6 col-md-7 col-lg-7 col-xl-7">
                            <h3 class="mt-1 mb-3 font-01"><strong>Peoples in Event</strong></h3>
                            <b-list-group>
                                <b-list-group-item class="mb-2" style="border-radius:5px;">
                                    <b-media>
                                        <h4 class="mt-0 mb-1 font-user-in">Nested Media</h4>
                                        <p class="font-01 mb-0">
                                            <strong class="font-log mr-2"><i class="fa fa-clock-o mr-2" aria-hidden="true" />Check - in</strong>:
                                        </p>
                                    </b-media>
                                </b-list-group-item>
                                <b-list-group-item class="mb-1" style="border-radius:5px;">
                                    <b-media>
                                        <h4 class="mt-0 mb-1 font-user-in">Nested Media</h4>
                                        <p class="font-01 mb-0">
                                            <strong class="font-log mr-2"><i class="fa fa-clock-o mr-2" aria-hidden="true" />Check - in</strong>:
                                        </p>
                                    </b-media>
                                </b-list-group-item>
                                <b-list-group-item class="mb-1" style="border-radius:5px;">
                                    <b-media>
                                        <h4 class="mt-0 mb-1 font-user-in">Nested Media</h4>
                                        <p class="font-01 mb-0">
                                            <strong class="font-log mr-2"><i class="fa fa-clock-o mr-2" aria-hidden="true" />Check - in</strong>:
                                        </p>
                                    </b-media>
                                </b-list-group-item>
                                <b-list-group-item class="mb-1" style="border-radius:5px;">
                                    <b-media>
                                        <h4 class="mt-0 mb-1 font-user-in">Nested Media</h4>
                                        <p class="font-01 mb-0">
                                            <strong class="font-log mr-2"><i class="fa fa-clock-o mr-2" aria-hidden="true" />Check - in</strong>:
                                        </p>
                                    </b-media>
                                </b-list-group-item>
                                <b-list-group-item class="mb-1" style="border-radius:5px;">
                                    <b-media>
                                        <h4 class="mt-0 mb-1 font-user-in">Nested Media</h4>
                                        <p class="font-01 mb-0">
                                            <strong class="font-log mr-2"><i class="fa fa-clock-o mr-2" aria-hidden="true" />Check - in</strong>:
                                        </p>
                                    </b-media>
                                </b-list-group-item>
                                <b-list-group-item class="mb-1" style="border-radius:5px;">
                                    <b-media>
                                        <h4 class="mt-0 mb-1 font-user-in">Nested Media</h4>
                                        <p class="font-01 mb-0">
                                            <strong class="font-log mr-2"><i class="fa fa-clock-o mr-2" aria-hidden="true" />Check - in</strong>:
                                        </p>
                                    </b-media>
                                </b-list-group-item>
                                <b-list-group-item class="mb-1" style="border-radius:5px;">
                                    <b-media>
                                        <h4 class="mt-0 mb-1 font-user-in">Nested Media</h4>
                                        <p class="font-01 mb-0">
                                            <strong class="font-log mr-2"><i class="fa fa-clock-o mr-2" aria-hidden="true" />Check - in</strong>:
                                        </p>
                                    </b-media>
                                </b-list-group-item>
                            </b-list-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                currentTime:null,
                countData: 0,
                hou: 0,
                sec: 5,
            }
        },
        methods:{
            updateCurrentTime() { this.currentTime = this.moment().locale('th').format('LTS'); },
        },
        created() {
            this.currentTime = this.moment().locale('th').format('LTS');
            setInterval(() => this.updateCurrentTime(), 1 * 1000);
        },  
    }
</script>

<style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Nunito&display=swap');
    .font-01{ 
        font-family: 'Kanit', sans-serif; font-weight: 100; 
    }
    .card-profile{
        background-color: #f3f3f3;
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
        transition: 0.3s;
    }
    .font-detail-profile{ 
        font-family: 'Kanit', sans-serif;
        font-size: 1.5rem;
    }
    .f-size-1{ font-size: 5rem; }
    .f-size-2{ font-size: 1.2rem; font-weight: 500; }
    .font-02{ 
        font-family: 'Kanit', sans-serif; 
        font-weight: 500;
        font-size: 1rem;
    }
    .font-user-in{
        font-family: 'Nunito', sans-serif; font-weight: 600; 
    }
    .font-log{ 
        font-family: 'Kanit', sans-serif;
    }
    .font-head-event{
        font-family: 'Kanit', sans-serif; font-weight: 500; 
    }
    .clock-warning{
        color: #5605af;
    }
    .a-announce{
        color: #1b1e21;
        background-color: #f9f9f9;
        border: 2px solid #000;
        padding: 15px;
        border-radius: 5px;
    }
    .a-profile{
        color: #1b1e21;
        background-color: #f9f9f9;
        padding: 15px;
        border-radius: 5px;
    }
</style>